import Cookies from 'js-cookie'
import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

const LEGAL_FLOW_KEY = 'nl'
const COOKIE_DOMAIN = '.saldoinvoice.com'

const useLegalFlow = (): boolean => {
  const location = useLocation()

  const getInitialValue = (): boolean => {
    try {
      const cookieValue = Cookies.get(LEGAL_FLOW_KEY)
      if (cookieValue === 'false') {
        return false
      }
      if (cookieValue === 'true') {
        return true
      }
    } catch (error) {
      console.error('Error reading legal flow cookie:', error)
    }

    // Default to true (show legal flow)
    return true
  }

  const [storedIsLegalFlow, setStoredIsLegalFlow] =
    useState<boolean>(getInitialValue)

  const isLegalFlow = useMemo(() => {
    const searchParams = new URLSearchParams(location.search)
    const nlParam = searchParams.get('nl')

    if (nlParam === '1') {
      return false
    }

    return storedIsLegalFlow
  }, [location.search, storedIsLegalFlow])

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const nlParam = searchParams.get('nl')

    if (nlParam === '1' && storedIsLegalFlow !== false) {
      const newValue = false
      setStoredIsLegalFlow(newValue)

      try {
        Cookies.set(LEGAL_FLOW_KEY, String(newValue), {
          expires: 365, // 1 year
          domain: COOKIE_DOMAIN,
          sameSite: 'Lax',
        })
      } catch (error) {
        console.error('Error storing cookie:', error)
      }
    }
  }, [location.search, storedIsLegalFlow])

  return isLegalFlow
}

export default useLegalFlow
